module.exports = __webpack_public_path__ + "static/media/torque.d845dfb2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/torque.jpg
 ** module id = 440
 ** module chunks = 0
 **/